import {EventTemplate } from "../../templates/EventTemplate/EventTemplate";

export const EventPage = () => {
  return <EventTemplate />;
};
